import { MapCenter } from './types';

export const staticServiceLocationsSearchData: Record<string, string> = {
  heading: 'Find a {{brandNameCasual}} pro in your area',
  subheading:
    'Same-day service available in {{serviceStates}}. Enter your ZIP code to find your nearest technicians.',
};

export const DEFAULT_MAP_CENTER = { lat: 40.05, lng: -75.35 };
export const DEFAULT_MAP_ZOOM = 9;
export const STATE_MAP_ZOOM = 7;
export const ZIP_RESULT_MAP_ZOOM = 13;

export const STATE_MAP_CENTERS: Record<string, MapCenter> = {
  PA: { lat: 40.8, lng: -77.8 }, // Pennsylvania
  NJ: { lat: 40.0, lng: -74.5 }, // New Jersey
  DE: { lat: 39.0, lng: -75.5 }, // Delaware
  MD: { lat: 39.0, lng: -76.7 }, // Maryland
  VA: { lat: 38.85, lng: -77.45 }, // Northern Virginia
  TX: { lat: 29.55, lng: -95.2 }, // Texas
  FL: { lat: 26.55, lng: -80.12 }, // Florida
};
